export default [

    {
        path: '/documentation',
        name: 'documentation-list',
        component: () => import('@/views/apps/documentation/views/List.vue'),
        meta: {
            // Документы открыты всем, кто вошёл: руководство нужно замерщику и
            // оператору не меньше, чем администратору
            resource: 'common',
            action: 'read',
            pageTitle: 'Документация',
            breadcrumb: [
                {
                    text: 'Документы пользователя',
                    active: true,
                },
            ],
        },
    },
]
